@let menuItems = items();
@if (menuItems) {
  <div class="playable-list content-list">
    @for (item of menuItems; track item.id) {
      <div class="list-item-wrapper">
        <pv2-playable-list-item
          [item]="item"
          [displayPlayButton]="displayPlayButtons()"
          [displayDuration]="displayDurations()"
          [eventSource]="eventSource()"
        >
        </pv2-playable-list-item>
      </div>
    }
  </div>
}
